import {
  object,
  array,
  number,
  string,
  collection,
  boolean,
} from '@gogame/schemas';

import {
  IDS,
  CONCEPT_FAMILIES,
  PROMO_CODE,
  CHANNELS,
  LANGUAGE,
  ENHANCERS,
  AI_GENERATED,
  TAGS,
  JIRA_TASK,
  REQUESTED_BY,
  POSTFIX,
  OUTSOURCE_STUDIO_ID,
  DESIGNER,
  DESCRIPTION,
  ATTACHMENTS,
  STATE_SCHEDULES,
  PRODUCTION_TYPE,
} from './constants';

export const validationSchema = object({
  [IDS]: array(number()),
  [CONCEPT_FAMILIES]: array(number()).nullable().default(null),
  [PROMO_CODE]: number().nullable().default(null),
  [CHANNELS]: array(number()).nullable().default(null),
  [LANGUAGE]: number().nullable().default(null),
  [PRODUCTION_TYPE]: number().nullable().default(null),
  [AI_GENERATED]: boolean().default(false),
  [ENHANCERS]: array(number()).nullable().default(null),
  [TAGS]: array(number()).nullable().default(null),
  [JIRA_TASK]: string().nullable().default(null),
  [REQUESTED_BY]: number().nullable().default(null),
  [POSTFIX]: string().nullable().default(null),
  [OUTSOURCE_STUDIO_ID]: number().nullable().default(null),
  [DESIGNER]: number().nullable().default(null),
  [DESCRIPTION]: string().nullable().default(null),
  [ATTACHMENTS]: collection(
    object({
      id: number(),
      name: string(),
    })
  )
    .nullable()
    .default(null),
  [STATE_SCHEDULES]: collection(
    object({
      state: number(),
      date: string(),
    })
  ).default([]),
});
